import ready from '../utils/ready';

class Header {

  constructor(header) {

    this.header        = header;
    this.contact       = header.querySelector('.js-header-contact');
    this.menu          = header.querySelector('.js-header-menu');
    this.frame         = null;
    this.lastOffset    = null;
    this.offset        = null;
    this.offsetMax     = this.contact.clientHeight;
    
    // IE 11 does not understand document.scrollingElement, using fallback for it
    this.scrollElement = (document.scrollingElement ? document.scrollingElement : document.documentElement);

    window.addEventListener('resize', this.resizeHandler.bind(this));
    window.addEventListener('scroll', this.scrollHandler.bind(this));
  }

  resizeHandler() {
    this.offsetMax = this.contact.clientHeight;
    this.scrollHandler();
  }

  scrollHandler() {

    this.offset = Math.abs(Math.min(this.scrollElement.scrollTop, this.offsetMax));
    
    if (this.offset === this.lastOffset) {
      // offset did not change, nothing to do.
      
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      return;
    }

    if (!this.frame) {
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
        this.lastOffset = this.offset;
      });
    }
  }

  update() {
    if (this.offset === this.offsetMax) {
      this.header.style.top       = `${-1 * this.offset}px`;
      this.header.style.transform = '';
    } else {
      this.header.style.top       = '';
      this.header.style.transform = `translate3d(0, ${-1 * this.offset}px, 0)`;
    }
  }
}

function init() {
  const header = document.querySelector('.js-header');
  
  if(!header) {
    return;
  }

  new Header(header);
}

ready(init);



// WEBPACK FOOTER //
// ./assets/src/js/components/header.js